<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>電力人才萌芽</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div class="sectTit">台灣民間電力人才的萌芽與茁壯</div>
        <br>
        <div class="left">
          <div>1990 年代，國內經濟快速發展、用電迅速成長，於是政府開放民間投資興建電廠以加速電源開發，和平電力就是那時第一批核准設立的民營電廠。</div><br>
          <div>身為台灣第一代的民營電廠，和平電力成立之初曾面臨缺乏有經驗人才的窘境，當時有電廠資歷的皆隸屬國營事業台電，民營公司如何將手握鐵飯碗的人才吸引過來？這真是難上加難！因此和平電力培訓自己的員工成當務之急。</div><br>
          <div>新人進來後，當務之急是將新人訓練成電廠專業人員，但問題又來了，除了台電之外，台灣並無電廠經營維護的相關課程或講師可聘用，因此當時和平電力還曾情商台電協助代訓電廠新進人員。</div>
        </div>
        <div class="right">
          <div class="imgContainer1-1">
            <div class="imgTit">2000 年建廠初期</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">草創時期 人才培力</div>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer2-1"></div>
            <div class="imgContainer2-2"></div>
            <div class="imgContainer2-3"></div>
          </div>
          <div class="right">
            <div class="imgContainer2-4"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <p>西元 2000 年和平電力舉辦大型招募活動，租借花蓮高商校區舉辦大型考試及面試，共招募了 188 位電廠生力軍，在當時花蓮還成了重要地方新聞。</p>
        <p>2001 年 1 月和平電力從新進人員中挑選出約 80 人做為種子教官，分成兩組參加培訓專班課程，3 月底基礎課程結束後，正式邁入第二階段的訓練 - 由 Alstom 原廠技師帶領專業訓練。將人員分成不同組別，針對電廠不同設備，進行現場的操作及學理解說，讓學員有更進一步的認識。</p>
        <p>在各路電力界英雄的努力下，和平電廠一號機組及二號機組分別於 2002 年 6 月 1 日及同年 9 月 6 日宣告商轉，這一年和平電力母公司台泥企業團正式跨入民營電廠的能源產業版圖，與電網上的機組共同扛起電源供應的重責大任，和平工業區內的循環經濟產業鏈也正式啟動。</p>
        <div class="sectTit">和電眾生相</div>
        <div class="employee">
          <div class="item" v-for="(row, idx) in employee" :key="idx">
            <div class="left">
              <div class="avatar" :style="setAvatar(row.avatar)"></div>
              <!-- <div class="avatar" :style="background:url(img/row.file)"></div> -->
              <div class="name">{{row.name}}</div>
              <div class="job">{{row.job}}</div>
            </div>
            <div class="right">{{row.desp}}</div>
            <div class="clear"></div>
            <div class="flag">
              <div class="seniority">年資</div>
              <div class="year">{{row.year}}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'AboutPowerTalent',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      employee: [
        {
          name: "黃武震",
          job: "電機部 副理",
          year: "28",
          desp: "我是和平村的居民，當時花蓮沒有什麼大企業，和平電廠才剛開始蓋，我覺得新廠應該會有很多新的東西可以學，台北工專剛畢業就來上班了。記得 2017 年當尼莎颱風吹倒電塔的時候，從平地到倒塌地點開車要 40 分鐘，再手腳併用的爬山 30 分鐘，那時路根本走不了，只好靠怪手搶修便道另外開路上去，以前電塔都是用流籠吊上山，但因為颱風地質鬆動，當時還得靠怪手一段段載上去，真的是日以繼夜的搶修，後來我們比預期的提早兩天修復。",
          avatar: "avatar_01.jpg"
        },
        {
          name: "吳皓祺",
          job: "鍋爐部 鍋爐維修組",
          year: "25",
          desp: "鍋爐的工作其實真的非常辛苦，因為煤炭燃燒時的溫度可高達 1,200℃，裡面的管線約數百公里，長度比台灣頭到台灣尾還長，發電過程中，鍋爐若發生破管，即使只有一根髮絲的裂痕，機組就必須停機，降溫到 40℃ 左右我們才能進去檢查，平時就靠著經驗在鍋爐外用 \"聽\" 的巡檢。還記得 0403 大地震時，當時剛好我已經到公司了，當餘震比較不頻繁的時候靠近去檢查，異常的出水就知道鍋爐內狀況很不妙，我連續在公司住了 3 天搶修，在團隊通力合作之下總算恢復供電。",
          avatar: "avatar_02.jpg"
        },
        {
          name: "曾義仁",
          job: "水務化驗部 水處理操作",
          year: "25",
          desp: "我是南澳澳花村的居民，一退伍就到和平電廠工作了，當時電廠才剛好開始商轉，我可以說是跟電廠一起成長至今，初入電廠我對許多事務一竅不通，但公司非常有心地栽培我們，每兩到三個月都會安排我們上課，提升我們的專業技能。在家鄉旁邊有這麼樣的就業機會真的非常好，因為離家很近也可以照顧父母。",
          avatar: "avatar_03.jpg"
        },
        {
          name: "白文斌",
          job: "輸儲機運部 機械維修",
          year: "20",
          desp: "和平電力是我人生唯一一個工作經驗，一退伍就到這裡上班到現在，我也是澳花村的村民，過去當電廠要蓋的時候，總覺得燃煤電廠很可怕，可能會造成空氣污染、環境破壞等，但實際進來工作以後發現根本沒這回事，而且在環境保護方面公司也做了很多努力，例如粉塵的收集，公司都會不斷更新。我印象最深的是公司真的對員工很好，之前我突發心臟病倒下緊急開刀，包含人力資源部還有所屬部門同事都主動幫我安排請假、募款……等，回來上班之後長官也很照顧我，減少我的工作量要讓我好好休養。",
          avatar: "avatar_04.jpg"
        }
      ]
    }
  },
  methods: {
    setAvatar: function(avatar: string) {
      return {
        background: `url(${require(`@/assets/aboutPowerTalent/${avatar}`)})`,
        backgroundSize: "cover"
      }
    }
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 0.9);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 0.9);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-2") as HTMLElement, 0.748);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-3") as HTMLElement, 0.483);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-4") as HTMLElement, 0.9);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/aboutPowerTalent/kv.webp");
  background-position: center 48%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect {
  /* padding: 40px; */
  /* box-sizing: border-box; */
}

.sect1 .sectTit {
  margin: 0 0 20px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 .left {
  width: 45%;
  float: left;
  line-height: 2em;
  letter-spacing: 1px;
}

.sect1 .right {
  width: 45%;
  float: right;
}

.sect1 .right .imgContainer1-1 {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  background: url(../../assets/aboutPowerTalent/pic1_01.jpg) center no-repeat;
  background-size: cover;
}

.sect1 .right .imgContainer1-1 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

.sect2 {
  background: url(../../assets/aboutPowerTalent/sectBack2.png) center no-repeat;
  background-size: cover;
}

.sect2 .sectTit {
  margin: 0 0 20px;
  text-align: center;
  font-size: 40px;
  color: #fff;
}

.sect2 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;  
}

.sect2 .gallery .left {
  flex: 0 0 49.7%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect2 .gallery .left .imgContainer2-1 {
  width: 45%;
  height: 44%;
  margin: 0 0 1%;
  background: url(../../assets/aboutPowerTalent/pic2_01.jpg) 20% center no-repeat;
  background-size: cover;
}

.sect2 .gallery .left .imgContainer2-2 {
  width: 54%;
  height: 44%;
  margin: 0 0 1% 1%;
  background: url(../../assets/aboutPowerTalent/pic2_02.jpg) center no-repeat;
  background-size: cover;
}

.sect2 .gallery .left .imgContainer2-3 {
  width: 100%;
  height: 55%;
  background: url(../../assets/aboutPowerTalent/pic2_03.jpg) center no-repeat;
  background-size: cover;
}

.sect2 .gallery .right {
  flex: 0 0 49.7%;
}

.sect2 .gallery .right .imgContainer2-4 {
  background: url(../../assets/aboutPowerTalent/pic2_04.jpg) center no-repeat;
  background-size: cover;
}

.sect3 {
  background: url(../../assets/aboutPowerTalent/sectBack3.png) center, #F4F3F3;
  background-repeat: no-repeat, no-repeat;
  background-position: center bottom, center;
  background-size: contain, cover;
}

.sect3 p {
  line-height: 2em;
  letter-spacing: 1px;
}

.sect3 .sectTit {
  width: 250px;
  margin: 40px auto;
  padding: 5px 20px;
  box-sizing: border-box;
  border-radius: 30px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  background: #F4F3F3;
}

.sect3 .employee {
 display: flex;
 justify-content: space-between;
 flex-wrap: wrap;
}

.sect3 .employee .item {
  flex: 0 0 48%;
  margin: 0 0 60px;
  padding: 25px;
  box-sizing: border-box;
  position: relative;
  border-bottom-right-radius: 60px;
  background: #E6EEF4;
  box-shadow: 8px 8px 0 #00000044;
}

.sect3 .employee .item:nth-child(odd) {
  background: #DFF1ED;
}

.sect3 .employee .item .left {
  width: 35%;
  float: left;
}

.sect3 .employee .item .left .avatar {
  width: 185px;
  height: 205px;
  margin: 0 auto 10px;
  background: #ccc;
}

.sect3 .employee .item .left .name {
  margin: 0 0 5px;
  text-align: center;
  font-size: 24px;
}

.sect3 .employee .item .left .job {
  margin: 0 0 20px;
  text-align: center;
  font-size: 14px;
}

.sect3 .employee .item .right {
  width: 60%;
  float: right;
  letter-spacing: 1px;
  line-height: 1.8em;
  font-size: 15px;
}

.sect3 .employee .item .flag {
  width: 50px;
  height: 65px;
  padding: 15px 0 0;
  position: absolute;
  top: 0;
  text-align: center;
  background: url(../../assets/aboutPowerTalent/sect3SeniorityFlag.png) no-repeat;
  background-size: contain;
}

.sect3 .employee .item .flag .seniority {
  font-size: 14px;
}

.sect3 .employee .item .flag .year {
  font-family: arial;
  font-weight: bold;
  font-size: 24px;
  color: #0C5F99;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 100%;
    margin: 40px 0 20px;
  }

  .sect3 .employee .item {
    flex: 0 0 100%;
    margin: 0 0 40px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 100%;
    margin: 20px 0 0;
  }

  .sect2 .sectTit {
    font-size: 24px;
  }

  .sect2 .gallery .left {
    flex: 0 0 100%;
  }

  .sect2 .gallery .left .imgContainer2-1 {
    width: 100%;
  }

  .sect2 .gallery .left .imgContainer2-2 {
    width: 100%;
  }

  .sect2 .gallery .right {
    flex: 0 0 100%;
  }

  .sect3 .ctx {
    padding: 40px 20px 0;
  }

  .sect3 .sectTit {
    width: 200px;
    font-size: 24px;
  }

  .sect3 .employee .item {
    flex: 0 0 100%;
  }

  .sect3 .employee .item .left {
    width: 100%;
    float: left;
  }

  .sect3 .employee .item .right {
    width: 100%;
    float: right;
  }

  .sect3 .employee .item .flag {
    left: 0;
  }
}
</style>
